function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { settleCaptchaApi, settleSendSmsApi, settleSubmitApi, settleAgreementApi, settlePrivacyApi } from '@/api/settle';
var PHONE_RE = /^1[3-9]\d{9}$/;
// 统一社会信用代码：18 位数字或大写字母，不使用 I、O、S、V、Z
var CREDIT_CODE_RE = /^[0-9A-HJ-NPQRTUWXY]{18}$/;
// 18 位身份证：6 位地址码 + 8 位出生日期 + 3 位顺序码 + 1 位校验位(数字或 X)
var ID_CARD_RE = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;

/**
 * 协议接口沿用平台协议存储格式，data 可能是 JSON 字符串，也可能已经是对象。
 * 统一提取 agreement 字段，避免把 {"agreement":"..."} 和转义换行直接显示给用户。
 */
function parseAgreementContent(payload) {
  if (payload == null) return '';
  var value = payload;
  if (typeof value === 'string') {
    var text = value.trim();
    if (!text) return '';
    try {
      value = JSON.parse(text);
    } catch (e) {
      value = text;
    }
  }
  if (value && _typeof(value) === 'object') value = value.agreement || value.content || '';
  return String(value || '').replace(/\\r\\n|\\n|\\r/g, '\n');
}
export default {
  name: 'MerchantSettle',
  data: function data() {
    // 协议必须勾选：后端 agreementAccepted 也会校验，这里先拦一道给出明确提示
    var validateAgreement = function validateAgreement(rule, value, callback) {
      if (!value) return callback(new Error('请阅读并同意相关协议'));
      callback();
    };
    return {
      form: {
        companyName: '',
        businessLicenseNo: '',
        legalPersonName: '',
        legalPersonCertNo: '',
        contactPerson: '',
        imageCaptcha: '',
        imageCaptchaKey: '',
        phone: '',
        smsCode: '',
        mainBusiness: '',
        agreementAccepted: false
      },
      rules: {
        companyName: [{
          required: true,
          message: '请输入公司名称',
          trigger: 'blur'
        }],
        businessLicenseNo: [{
          required: true,
          message: '请输入统一社会信用代码',
          trigger: 'blur'
        }, {
          pattern: CREDIT_CODE_RE,
          message: '统一社会信用代码必须为18位大写字母或数字',
          trigger: 'blur'
        }],
        legalPersonName: [{
          required: true,
          message: '请输入法人姓名',
          trigger: 'blur'
        }],
        legalPersonCertNo: [{
          required: true,
          message: '请输入法人身份证号',
          trigger: 'blur'
        }, {
          pattern: ID_CARD_RE,
          message: '身份证号格式不正确',
          trigger: 'blur'
        }],
        contactPerson: [{
          required: true,
          message: '请输入联系人',
          trigger: 'blur'
        }],
        imageCaptcha: [{
          required: true,
          message: '请输入图片验证码',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入联系方式',
          trigger: 'blur'
        }, {
          pattern: PHONE_RE,
          message: '手机号格式不正确',
          trigger: 'blur'
        }],
        smsCode: [{
          required: true,
          message: '请输入手机验证码',
          trigger: 'blur'
        }, {
          pattern: /^\d{6}$/,
          message: '手机验证码为6位数字',
          trigger: 'blur'
        }],
        mainBusiness: [{
          required: true,
          message: '请输入主营内容说明',
          trigger: 'blur'
        }],
        agreementAccepted: [{
          validator: validateAgreement,
          trigger: 'change'
        }]
      },
      captchaImg: '',
      sending: false,
      submitting: false,
      smsCountdown: 0,
      smsTimer: null,
      agreementVisible: false,
      agreementLoading: false,
      agreementTitle: '',
      agreementContent: ''
    };
  },
  created: function created() {
    this.loadCaptcha();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.smsTimer) clearInterval(this.smsTimer);
  },
  methods: {
    normalizeBusinessLicenseNo: function normalizeBusinessLicenseNo(value) {
      this.form.businessLicenseNo = (value || '').trim().toUpperCase();
    },
    goLogin: function goLogin() {
      this.$router.push('/login');
    },
    loadCaptcha: function () {
      var _loadCaptcha = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return settleCaptchaApi();
            case 1:
              res = _context.v;
              this.captchaImg = res && res.code ? res.code : '';
              this.form.imageCaptchaKey = res && res.key || '';
              this.form.imageCaptcha = '';
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.captchaImg = '';
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadCaptcha() {
        return _loadCaptcha.apply(this, arguments);
      }
      return loadCaptcha;
    }(),
    onSendSms: function () {
      var _onSendSms = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (PHONE_RE.test(this.form.phone)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, this.$message.warning('请先填写正确的手机号'));
            case 1:
              this.sending = true;
              _context2.p = 2;
              _context2.n = 3;
              return settleSendSmsApi(this.form.phone);
            case 3:
              this.$message.success('验证码已发送');
              this.startCountdown();
            case 4:
              _context2.p = 4;
              this.sending = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[2,, 4, 5]]);
      }));
      function onSendSms() {
        return _onSendSms.apply(this, arguments);
      }
      return onSendSms;
    }(),
    startCountdown: function startCountdown() {
      var _this = this;
      this.smsCountdown = 60;
      if (this.smsTimer) clearInterval(this.smsTimer);
      this.smsTimer = setInterval(function () {
        _this.smsCountdown -= 1;
        if (_this.smsCountdown <= 0) clearInterval(_this.smsTimer);
      }, 1000);
    },
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        var _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.form.companyName = this.form.companyName.trim();
              this.form.businessLicenseNo = this.form.businessLicenseNo.trim().toUpperCase();
              this.form.legalPersonName = this.form.legalPersonName.trim();
              this.form.legalPersonCertNo = this.form.legalPersonCertNo.trim().toUpperCase();
              this.form.contactPerson = this.form.contactPerson.trim();
              _context3.n = 1;
              return this.$refs.formRef.validate();
            case 1:
              this.submitting = true;
              _context3.p = 2;
              _context3.n = 3;
              return settleSubmitApi(_objectSpread({}, this.form));
            case 3:
              this.$alert('申请已提交，平台审核通过后会以短信通知您，请留意手机。', '提交成功', {
                type: 'success',
                confirmButtonText: '知道了',
                callback: function callback() {
                  return _this2.goLogin();
                }
              });
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t2 = _context3.v;
              // 图片验证码是一次性的，提交失败必须换一张，否则用户重试必然再次失败
              this.loadCaptcha();
            case 5:
              _context3.p = 5;
              this.submitting = false;
              return _context3.f(5);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 4, 5, 6]]);
      }));
      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }(),
    openAgreement: function () {
      var _openAgreement = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(type) {
        var payload, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.agreementTitle = type === 'settle' ? '店铺用户服务协议' : '隐私保护政策';
              this.agreementContent = '';
              this.agreementVisible = true;
              this.agreementLoading = true;
              _context4.p = 1;
              if (!(type === 'settle')) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return settleAgreementApi();
            case 2:
              _t3 = _context4.v;
              _context4.n = 5;
              break;
            case 3:
              _context4.n = 4;
              return settlePrivacyApi();
            case 4:
              _t3 = _context4.v;
            case 5:
              payload = _t3;
              this.agreementContent = parseAgreementContent(payload);
            case 6:
              _context4.p = 6;
              this.agreementLoading = false;
              return _context4.f(6);
            case 7:
              return _context4.a(2);
          }
        }, _callee4, this, [[1,, 6, 7]]);
      }));
      function openAgreement(_x) {
        return _openAgreement.apply(this, arguments);
      }
      return openAgreement;
    }()
  }
};